import { forwardRef, type ReactNode } from 'react';
import { contentWidth, sectionPad, tones, type SectionPad, type Tone } from '../../ui/sections';
type Props = {
  /** De toon van het vlak; de tekstkleur hoort erbij (klei en salie: shell). */
  tone: Tone;
  children: ReactNode;
  /** Id van de kop in deze sectie (voorkeur), of anders een naam voor schermlezers. */
  labelledBy?: string;
  label?: string;
  id?: string;
  pad?: SectionPad;
  /** Extra klassen op de binnenkant (raster, gaten); de breedte en zijmarge staan al vast. */
  className?: string;
  /** Extra klassen op het vlak zelf, alleen voor gedrag (bijv. `scroll-mt-24` bij een ankertje). */
  sectionClassName?: string;
  /** `false`: geen inhoudsbreedte (beeld tot de rand, of een eigen raster); de sectie geeft dan alleen toon en ruimte. */
  contained?: boolean;
};

/**
 * De sectiebouwsteen van de publieke site: één toon, vaste verticale ruimte en de inhoudsbreedte.
 * Een pagina is een rij van deze vlakken (docs/VORMGEVING.md › Bouwstenen). Een sectievlak
 * dat de vaste ruimte zelf uitschrijft, weigert de stijlcontrole (shop/publicStyle.test.ts).
 * De ref gaat naar het vlak (voor scroll-effecten zoals de reviews op Home).
 */
export const Section = forwardRef<HTMLElement, Props>(function Section({
  tone,
  children,
  labelledBy,
  label,
  id,
  pad = 'default',
  className = '',
  sectionClassName = '',
  contained = true
}, ref) {
  return <section ref={ref} id={id} className={`${tones[tone]} ${sectionPad[pad]} ${sectionClassName}`} aria-labelledby={labelledBy} aria-label={labelledBy ? undefined : label} data-id="element-8812" data-mp="258u962w9b3c3">
      {contained ? <div className={`${contentWidth} ${className}`} data-id="element-8813" data-mp="1w8nzyt7lcpiq">{children}</div> : children}
    </section>;
});